import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";

export default class ItemView extends AbstractView {

    constructor(target) {
        super(target);
        
        this._target.mouseChildren = false;
        this._target.gotoAndStop(0);                
        this.content = null;
        this.show(false);
    }

    get target() {
        return this._target;
    }

    set content(skin) {
        this._target.removeAllChildren();
        this._content = skin;
        if (skin) {
            this._target.addChild(skin);
            skin._scaleX = skin._scaleY = this._scale;
        }
    }

    get content() {
        return this._content;
    }

    show(bool) {        
        this._target.visible = bool;
    }

    animate(delay = 1000, fadeInDuration = 300, fadeOutDuration = 300) {
        const durationAnimation = delay + fadeInDuration + fadeOutDuration;

        this._target.alpha = 0;
        this._target.visible = true;

        createjs.Tween.get(this._target)
        .to({ alpha: 1 }, fadeInDuration, createjs.Ease.quadOut)
        .wait(durationAnimation)
        .to({ alpha: 0 }, fadeOutDuration, createjs.Ease.quadOut);
    }
}

